module.exports = __webpack_public_path__ + "img/icon_title.18da6c68.svg";